/* The Rub Hub — Hover Showreel + layered header fire
   REEL BEHAVIOUR (updated 2026-07-19): reels NEVER autoplay. The old
   "scroll into view -> play one pass" autoplay has been removed. A reel only
   cycles while its own card is hovered, keyboard-focused, or tapped; leaving
   the card resets it to frame 1. Reels inside a dropdown / predictive-search /
   search modal are FROZEN on frame 1 (see FROZEN_SEL). Touch devices use
   tap-to-preview (first tap flips the carousel + holds navigation, second tap
   opens the product).
   Fire: .rh-firebed inside each .section-header-advanced — glowing coal bed,
   coal lumps, jagged charcoal cracks, hotspots, organic flame tongues, smoke
   wisps. Embers: one .rh-emberfield per header + .rh-annembers in the
   announcement bar. Desktop advanced header only. Respects prefers-reduced-motion. */
(function(){
  'use strict';
  var INTERVAL_DEFAULT = 800;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = new WeakMap();
  var activePreview = null; // touch: the reel currently in tap-preview

  // Touch / no-hover device? (phones) -> tap-to-preview instead of hover.
  function tapDevice(){ return window.matchMedia ? window.matchMedia('(hover: none)').matches : ('ontouchstart' in window); }

  /* Containers whose reels must stay static on frame 1 (never cycle):
     predictive-search dropdown, search modal, mega-menu, or any opt-out. */
  var FROZEN_SEL = "[data-reel-freeze],.quickSearchResultsWrap,.predictive-search,.quickSearch," +
                   ".search-modal,.search-modal__form,.header__search,.mega-menu,.header__submenu";

  function frames(reel){ return reel.querySelectorAll('[data-reel-frame]'); }
  function showFrame(fs, i){ for(var k=0;k<fs.length;k++){ fs[k].classList.toggle('is-active', k===i); } }
  function warm(fs){ for(var k=0;k<fs.length;k++){ var im = fs[k].tagName==='IMG'?fs[k]:fs[k].querySelector('img'); if(im && im.decode){ try{ im.decode().catch(function(){}); }catch(e){} } } }
  function intervalFor(reel){ var n = parseInt(reel.getAttribute('data-reel-interval'),10); return (isNaN(n)||n<200)?INTERVAL_DEFAULT:n; }
  function closestReel(node){ return node && node.closest ? node.closest('[data-hover-reel]') : null; }

  /* True when the reel sits inside a dropdown/search container. */
  function isFrozen(reel){ return !!(reel && reel.closest && reel.closest(FROZEN_SEL)); }

  function play(reel){
    if(reduceMotion) return;
    // Never cycle inside a dropdown/search — pin to frame 1 and bail.
    if(isFrozen(reel)){ var ff = frames(reel); if(ff.length){ showFrame(ff,0); } return; }
    var fs = frames(reel);
    if(fs.length < 2) return;
    var st = state.get(reel) || {timer:null,index:0,warmed:false};
    if(st.timer) return;
    if(!st.warmed){ warm(fs); st.warmed = true; }
    st.index = 0; showFrame(fs,0);
    st.timer = setInterval(function(){ st.index = (st.index+1) % fs.length; showFrame(fs, st.index); }, intervalFor(reel));
    state.set(reel, st);
  }
  function stop(reel, reset){
    var st = state.get(reel);
    if(st && st.timer){ clearInterval(st.timer); st.timer=null; }
    if(reset){ var fs = frames(reel); if(fs.length){ showFrame(fs,0); } if(st){ st.index=0; } }
    if(st) state.set(reel, st);
  }

  /* Activation is interaction-only: hover, keyboard focus, or tap. */
  document.addEventListener('mouseover', function(e){ var reel = closestReel(e.target); if(reel && !reel.contains(e.relatedTarget)) play(reel); });
  document.addEventListener('mouseout', function(e){ var reel = closestReel(e.target); if(reel && !reel.contains(e.relatedTarget)) stop(reel, true); });
  document.addEventListener('focusin', function(e){ var reel = closestReel(e.target); if(reel) play(reel); });
  document.addEventListener('focusout', function(e){ var reel = closestReel(e.target); if(reel && !reel.contains(e.relatedTarget)) stop(reel, true); });

  /* Click / tap handling.
     Hover devices (desktop): a click just ensures the reel is playing; never blocks the link.
     Touch devices (phones): tap-to-preview — first tap on a 2+ image card flips the carousel and
     holds the tap from opening the product; a second tap on that card opens it. Single-image cards
     and search-dropdown tiles open on the first tap. */
  document.addEventListener('click', function(e){
    var reel = closestReel(e.target);
    if(!reel){ if(activePreview){ stop(activePreview, true); activePreview = null; } return; }
    if(isFrozen(reel)) return;                 // dropdown/search tiles open normally
    if(!tapDevice()){ play(reel); return; }    // desktop: ensure playing, allow navigation
    if(frames(reel).length < 2) return;        // single image -> open normally
    if(reel !== activePreview){                // first tap -> preview, hold navigation
      e.preventDefault();
      if(activePreview && activePreview !== reel) stop(activePreview, true);
      activePreview = reel;
      play(reel);
    }
    // second tap on the same card -> do nothing here; the link opens the product
  });

  /* Prep only: show frame 1, mark ready. NO autoplay, NO scroll observer. */
  function initRest(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    var reels = scope.querySelectorAll('[data-hover-reel]');
    Array.prototype.forEach.call(reels, function(r){
      if(r.__reelInit) return;
      r.__reelInit = true;
      var fs = frames(r);
      if(fs.length){ showFrame(fs, 0); }
      r.classList.add('reel-ready');
      if(isFrozen(r)) r.classList.add('reel-frozen'); // CSS belt-and-braces
    });
  }

  /* ---- fire helpers ---- */
  var fireMQ = window.matchMedia ? window.matchMedia('(min-width:1025px)') : null;
  function desktopFire(){ return fireMQ ? fireMQ.matches : (window.innerWidth >= 1025); }
  function childByClass(host, cls){ for(var i=0;i<host.children.length;i++){ var c=host.children[i]; if(c.classList && c.classList.contains(cls)) return c; } return null; }

  function addEmber(host, riseMin, riseRange, spread){
    var em = document.createElement('span'); em.className = 'rh-ember';
    var s = (2 + Math.random()*2.4).toFixed(1);
    em.style.width = s+'px'; em.style.height = s+'px';
    em.style.left = (Math.random()*100).toFixed(2)+'%';
    em.style.setProperty('--rise', (riseMin + Math.random()*riseRange).toFixed(0)+'px');
    em.style.setProperty('--dx', (Math.random()*spread - spread/2).toFixed(0)+'px');
    em.style.animationDuration = (5 + Math.random()*5).toFixed(2)+'s';
    em.style.animationDelay = (-(Math.random()*10)).toFixed(2)+'s';
    host.appendChild(em);
  }
  function addSpark(host, riseMin, riseRange, spread){
    var sp = document.createElement('span'); sp.className = 'rh-spark';
    sp.style.left = (Math.random()*100).toFixed(2)+'%';
    sp.style.setProperty('--rise', (riseMin + Math.random()*riseRange).toFixed(0)+'px');
    sp.style.setProperty('--dx', (Math.random()*spread - spread/2).toFixed(0)+'px');
    sp.style.animationDuration = (3 + Math.random()*3).toFixed(2)+'s';
    sp.style.animationDelay = (-(Math.random()*6)).toFixed(2)+'s';
    host.appendChild(sp);
  }

  function rnd(a,b){ return a + Math.random()*(b-a); }

  /* jagged glowing orange cracks between the coals (embers) */
  function crackPoly(){
    var n = Math.floor(rnd(4,8)), tp = [], bp = [];
    for(var k=0;k<=n;k++){
      var x = (k/n)*100;
      var yc = rnd(38,62), th = rnd(6,16);
      tp.push(x.toFixed(0)+'% '+Math.max(0,yc-th).toFixed(0)+'%');
      bp.unshift(x.toFixed(0)+'% '+Math.min(100,yc+th).toFixed(0)+'%');
    }
    return 'polygon('+tp.concat(bp).join(',')+')';
  }
  function buildCracks(host, count){
    for(var i=0;i<count;i++){
      var c = document.createElement('span');
      c.className = 'rh-crack';
      c.style.setProperty('--cw', rnd(22,66).toFixed(0)+'px');
      c.style.setProperty('--ch', rnd(5,13).toFixed(0)+'px');
      c.style.setProperty('--cclip', crackPoly());
      c.style.setProperty('--cr', rnd(-24,24).toFixed(0)+'deg');
      c.style.setProperty('--cop', rnd(0.6,1).toFixed(2));
      c.style.setProperty('--pd', rnd(2.4,4.6).toFixed(2)+'s');
      c.style.setProperty('--dl', rnd(0,3).toFixed(2)+'s');
      c.style.left = rnd(-2,98).toFixed(1)+'%';
      c.style.bottom = rnd(-2,10).toFixed(1)+'px';
      host.appendChild(c);
    }
  }

  /* organic low flame tongues — run all the way along, gentle heights */
  function buildFlames(flames){
    var FLAME_COUNT = 42, FMIN = 23, FMAX = 46;
    var slot = 100 / FLAME_COUNT;
    for (var i=0;i<FLAME_COUNT;i++){
      var f = document.createElement('span');
      f.className = 'rh-flame';
      /* even slots across the full width + small jitter, so flames run all the way along */
      var left = Math.max(-2, Math.min(98, (i + 0.5) * slot + rnd(-slot*0.35, slot*0.35)));
      var t = Math.random();
      var h = t < 0.6 ? rnd(FMIN,(FMIN+FMAX)/2) : rnd((FMIN+FMAX)/2,FMAX);
      f.style.setProperty('--fh', h.toFixed(0)+'px');
      f.style.setProperty('--fw', rnd(14,26).toFixed(0)+'px');
      f.style.setProperty('--fd', rnd(3.0,5.0).toFixed(2)+'s');
      f.style.setProperty('--fdl', rnd(0,2.6).toFixed(2)+'s');
      f.style.setProperty('--lean', rnd(-6,6).toFixed(1)+'deg');
      f.style.left = left.toFixed(2)+'%';
      f.style.bottom = rnd(-2,4).toFixed(1)+'px';
      flames.appendChild(f);
    }
  }

  function jaggedPoly(){
    var n = Math.floor(rnd(4,7)), pts = [];
    for(var k=0;k<=n;k++){
      var x = (k/n)*100;
      var y = (k===0||k===n) ? rnd(58,82) : rnd(10,56);
      pts.push(x.toFixed(0)+'% '+y.toFixed(0)+'%');
    }
    return 'polygon(0% 100%,'+pts.join(',')+',100% 100%)';
  }

  /* bright ember hotspots — real heat coming through */
  function buildHotspots(host, count){
    for(var i=0;i<count;i++){
      var h = document.createElement('span');
      h.className = 'rh-hotspot';
      var sz = rnd(8,20);
      h.style.width = sz.toFixed(0)+'px'; h.style.height = sz.toFixed(0)+'px';
      h.style.left = rnd(-2,99).toFixed(1)+'%';
      h.style.bottom = rnd(-3,7).toFixed(1)+'px';
      h.style.setProperty('--pd', rnd(2.0,3.8).toFixed(2)+'s');
      h.style.setProperty('--dl', rnd(0,3).toFixed(2)+'s');
      host.appendChild(h);
    }
  }

  /* smooth little coals: rounded pebbles, orange underside + grey/ash top, packed dense */
  function buildLumps(host, count, backish){
    var clusters = [], nc = 10 + Math.floor(rnd(0,4));
    for(var c=0;c<nc;c++) clusters.push(rnd(2,98));
    for(var i=0;i<count;i++){
      var L = document.createElement('span');
      L.className = 'rh-lump';
      var big = Math.random() < 0.10;
      L.style.setProperty('--lw', (big?rnd(20,34):rnd(6,18)).toFixed(0)+'px');
      L.style.setProperty('--lh', (big?rnd(10,16):rnd(4,12)).toFixed(0)+'px');
      var r = Math.random(), base, top, edge;
      if(r > 0.82){ base=rnd(12,32);  top=rnd(28,58);   edge=rnd(54,96); }    /* black / near-black */
      else if(r > 0.55){ base=rnd(40,80); top=rnd(84,130); edge=rnd(130,172); } /* mid grey */
      else { base=rnd(96,178); top=rnd(160,218); edge=rnd(198,232); }          /* light grey / ashy */
      base=Math.round(base); top=Math.round(top); edge=Math.round(edge);
      L.style.setProperty('--l2', 'rgb('+base+','+(base-6)+','+(base-12)+')');
      L.style.setProperty('--l1', 'rgb('+top+','+(top-6)+','+(top-12)+')');
      L.style.setProperty('--le', 'rgb('+edge+','+(edge-4)+','+(edge-10)+')');
      L.style.setProperty('--op', rnd(backish?0.42:0.62, backish?0.8:0.96).toFixed(2));
      var br = rnd(42,58).toFixed(0)+'% '+rnd(42,58).toFixed(0)+'% '+rnd(44,56).toFixed(0)+'% '+rnd(44,56).toFixed(0)+'% / '+rnd(56,72).toFixed(0)+'% '+rnd(56,72).toFixed(0)+'% '+rnd(34,46).toFixed(0)+'% '+rnd(34,46).toFixed(0)+'%';
      L.style.setProperty('--br', br);
      var left = (Math.random()<0.25) ? clusters[Math.floor(rnd(0,clusters.length))] + rnd(-6,6) : rnd(-3,99);
      L.style.left = Math.max(-3, Math.min(99, left)).toFixed(1)+'%';
      L.style.bottom = rnd(-3, backish?8:13).toFixed(1)+'px';
      host.appendChild(L);
    }
  }

  /* occasional smoke wisps that rise the full header and drift off the top (no haze) */
  function buildSmoke(hdr){
    var old = childByClass(hdr, 'rh-smoke');
    if(old) hdr.removeChild(old);
    var layer = document.createElement('div');
    layer.className = 'rh-smoke'; layer.setAttribute('aria-hidden','true');
    hdr.appendChild(layer);
    if(reduceMotion) return;
    var H = Math.max(90, Math.round(hdr.getBoundingClientRect().height));
    for(var i=0;i<13;i++){
      var w = document.createElement('span');
      w.className = 'rh-wisp';
      w.style.left = rnd(2,97).toFixed(1)+'%';
      w.style.setProperty('--sw', rnd(16,30).toFixed(0)+'px');
      w.style.setProperty('--sh', rnd(60,110).toFixed(0)+'px');
      w.style.setProperty('--sd', rnd(9,17).toFixed(1)+'s');
      w.style.setProperty('--sdl', (-rnd(0,20)).toFixed(1)+'s');
      w.style.setProperty('--sx', rnd(-40,40).toFixed(0)+'px');
      w.style.setProperty('--sway', ((Math.random()<0.5?-1:1)*rnd(16,36)).toFixed(0)+'px');
      w.style.setProperty('--srise', (-(H+80)).toFixed(0)+'px');
      layer.appendChild(w);
    }
  }

  /* in-header fire layers only (no embers here) */
  function buildOneFire(hdr){
    var old = childByClass(hdr, 'rh-firebed');
    if(old) hdr.removeChild(old);
    var fb = document.createElement('div');
    fb.className = 'rh-firebed';
    fb.setAttribute('aria-hidden','true');
    var glow = document.createElement('div'); glow.className = 'rh-coalglow'; fb.appendChild(glow);
    var bed2 = document.createElement('div'); bed2.className = 'rh-coalbed'; fb.appendChild(bed2);
    var back = document.createElement('div'); back.className = 'rh-coalback'; fb.appendChild(back); buildLumps(back, 180, true);
    var dots = document.createElement('div'); dots.className = 'rh-coaldots'; fb.appendChild(dots); buildCracks(dots, 34); buildHotspots(dots, 16);
    var strip = document.createElement('div'); strip.className = 'rh-coalstrip'; fb.appendChild(strip); buildLumps(strip, 345, false);
    var flames = document.createElement('div'); flames.className = 'rh-flames'; fb.appendChild(flames); buildFlames(flames);
    hdr.insertBefore(fb, hdr.firstChild);
  }

  /* one continuous ember field: header base -> page top (through the announcement bar) */
  function fieldHeight(hdr){
    var hr = hdr.getBoundingClientRect();
    return Math.max(80, Math.min(Math.round(hr.height), 420));
  }
  function buildEmberField(hdr){
    var old = childByClass(hdr, 'rh-emberfield');
    if(old) hdr.removeChild(old);
    var f = document.createElement('div');
    f.className = 'rh-emberfield';
    f.setAttribute('aria-hidden','true');
    var H = fieldHeight(hdr);
    f.style.height = H + 'px';
    if(!reduceMotion){
      var i;
      for(i=0;i<28;i++){ addEmber(f, H*0.98, H*0.16, 58); }
      for(i=0;i<14;i++){ addSpark(f, H*0.98, H*0.16, 84); }
    }
    hdr.appendChild(f);
  }

  /* embers inside the announcement bar (behind the text), rising through + out the top */
  function buildAnnEmbers(){
    var ann = document.querySelector('.announcement-bar');
    if(!ann) return;
    for(var i=0;i<ann.children.length;i++){ var c=ann.children[i]; if(c.classList && c.classList.contains('rh-annembers')){ ann.removeChild(c); break; } }
    if(!desktopFire()) return;
    var H = Math.max(20, Math.round(ann.getBoundingClientRect().height));
    var fld = document.createElement('div');
    fld.className = 'rh-annembers'; fld.setAttribute('aria-hidden','true');
    fld.style.height = H + 'px';
    if(!reduceMotion){
      var e;
      for(e=0;e<22;e++){ addEmber(fld, H+10, 70, 44); }
      for(e=0;e<10;e++){ addSpark(fld, H+16, 66, 60); }
    }
    ann.insertBefore(fld, ann.firstChild);
  }

  function ensureFire(){
    var stray = document.getElementById('rh-emberfield');   /* remove any old body-level field */
    if(stray && stray.parentNode) stray.parentNode.removeChild(stray);
    if(!desktopFire()) return;
    var hdrs = document.querySelectorAll('.section-header-advanced');
    buildAnnEmbers();
    Array.prototype.forEach.call(hdrs, function(h){
      if(!childByClass(h, 'rh-firebed')) buildOneFire(h);
      buildEmberField(h);
      buildSmoke(h);
    });
  }
  var fireTimer = null;
  function scheduleFire(){ clearTimeout(fireTimer); fireTimer = setTimeout(ensureFire, 160); }

  function ready(fn){ if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', fn);} else { fn(); } }
  ready(function(){
    initRest(document);
    ensureFire();
    if('MutationObserver' in window){
      var mo = new MutationObserver(function(muts){
        for(var i=0;i<muts.length;i++){
          var added = muts[i].addedNodes;
          for(var j=0;j<added.length;j++){
            var n = added[j];
            if(n.nodeType===1){
              initRest(n);
              if((n.classList && n.classList.contains('section-header-advanced')) || (n.querySelector && n.querySelector('.section-header-advanced'))){ scheduleFire(); }
            }
          }
        }
      });
      mo.observe(document.body, {childList:true, subtree:true});
    }
  });
  window.addEventListener('load', scheduleFire);
  window.addEventListener('resize', scheduleFire);
  document.addEventListener('shopify:section:load', function(e){ initRest(e.target); scheduleFire(); });
  window.RubHubHoverReel = { init: initRest, buildFire: ensureFire };
})();
